import {
  useGetLearnerNoteQuery,
  useGetLearnerNotesForStudentQuery,
} from '@/app/redux/endpoints/learnerNotes';

export function useLearnerNote(id: string | undefined) {
  const {
    data: learnerNote = null,
    isLoading,
    isFetching,
    error,
  } = useGetLearnerNoteQuery(id!, { skip: !id });

  return { learnerNote, isLoading, isFetching, error };
}

export function useLearnerNotesForStudent(orgId: string, studentId: string) {
  const skip = !orgId || !studentId;
  const {
    data: notes = [],
    isLoading,
    isFetching,
    error,
  } = useGetLearnerNotesForStudentQuery({ orgId, studentId }, { skip });

  return { notes, isLoading, isFetching, error };
}
